/**
 * @velyn-custom — vely-feature-media-grid.js
 * Ensures <carousel-mobile> inside mobile tracks initializes on small screens.
 * Theme CarouselMobile can miss init when the node starts display:none (desktop DOM).
 */
(function () {
  var MOBILE_MAX = 767;

  function isMobile() {
    return window.innerWidth <= MOBILE_MAX;
  }

  function ensureCarousel(el) {
    if (!el || typeof el.actionOnMobile !== 'function') return;
    if (!isMobile()) return;
    if (el.classList.contains('swiper') && el.querySelector('.swiper-wrapper')) return;
    try {
      el.actionOnMobile();
    } catch (err) {
      /* ignore */
    }
  }

  function ensureAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope
      .querySelectorAll(
        'carousel-mobile.vely-fmg__mobile-track, .vely-fmg__peek > carousel-mobile, .vely-fmg__peek carousel-mobile'
      )
      .forEach(ensureCarousel);
  }

  function onReady() {
    ensureAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  document.addEventListener('shopify:section:load', function (event) {
    ensureAll(event.target || document);
  });

  var resizeTimer;
  window.addEventListener(
    'resize',
    function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        if (isMobile()) {
          ensureAll(document);
        }
      }, 200);
    },
    { passive: true }
  );
})();
